import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { userContext } from "../context/UserContext";
import DashboardSideBar from "../component/DashboardSideBar";
import { api_url } from "../helpers";

const Address = () => {
  const navigate = useNavigate();
  const { setUser, user, setLoad } = useContext(userContext);
  const [addresses, setAdresses] = useState([]);

  async function fetchAddress() {
    setLoad(true);
    const fields = JSON.stringify(["*"]);
    const filters = JSON.stringify([
      ["Dynamic Link", "link_name", "like", user?.customer_id],
    ]);
    const responsData = await fetch(
      api_url +
        `resource/Address?fields=${encodeURIComponent(
          fields
        )}&limit_page_length=20&limit_start=0&filters=${encodeURIComponent(
          filters
        )}`,
      {
        headers: {
          Authorization: `token ${user?.api_key}:${user?.api_secret}`,
        },
      }
    );

    if (responsData.ok == true) {
      const data = await responsData.json();

      if (data?.data?.length > 0) {
        setAdresses(data?.data);
      }
    }

    setTimeout(() => {
      setLoad(false);
    }, 300);
  }

  useEffect(() => {
    fetchAddress();
  }, []);

  return (
    <section>
      <div className="container UserDetails-custom">
        <div className="row">
          <DashboardSideBar
            currentPage="address"
            navigate={navigate}
            setUser={setUser}
          />

          {addresses?.length > 0 ? (
            <div className="col-lg-9 mt-24">
              <h5 className="mx-8">Saved Addresses</h5>
              {addresses?.map((item, index) => (
                <div className="Address-right-side-location" key={index}>
                  <h6 className="mb-1 p-0">{item?.address_title}</h6>
                  <p className="p-0 m-0">
                    {item?.address_line1}
                    {item?.address_line2}
                  </p>
                  <p className="p-0 m-0">City: {item?.city}</p>
                  <p className="p-0 mb-7">Pincode : &nbsp; {item?.pincode}</p>
                </div>
              ))}
            </div>
          ) : (
            <div className="d-flex flex-column align-items-center col-lg-9 my-36">
              <div className="w-50 d-flex justify-content-center">
                <img
                  src="assets/images/bg/norecordfound.png"
                  alt=""
                  className=""
                />
              </div>
              <div className="mt-40">
                <h3 className="d-flex justify-content-center">
                  No Record Found!
                </h3>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Address;
